import { Breadcrumb } from "antd";
import { Link } from "react-router";
import { type TrailEntry } from "../context/BreadcrumbTrailContext.ts";
import { useBreadcrumbTrail } from "../hooks/useBreadcrumbTrail.ts";

const EntryLabel = ({ entry }: { readonly entry: TrailEntry }) => {
  const Icon = entry.icon;
  const label = entry.label || "\u2026";
  return Icon ? (
    <>
      <Icon /> {label}
    </>
  ) : (
    label
  );
};

// eslint-disable-next-line react/no-multi-comp
export const BreadcrumbTrail = () => {
  const { trail } = useBreadcrumbTrail();

  const trailEntries = trail.slice(0, -1);
  if (trailEntries.length === 0) {
    return null;
  }

  return (
    <Breadcrumb
      items={trailEntries.map((entry) => ({
        title: (
          <Link to={entry.path + (entry.search ?? "") + (entry.hash ?? "")}>
            <EntryLabel entry={entry} />
          </Link>
        ),
      }))}
    />
  );
};
